import { useCallback } from 'react'
import { Modal, Button } from 'antd'
import { TranslationKeys } from '../../Constants/TranslationKeys'
import { renderTranslation } from '../../Helpers/GenericHelpers'
import { toggleChangeModal } from '../../Slices/Settings/SettingsSlice'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { useNavigateWrapper } from 'Helpers/NavigateHelper'

function SettingsChangeModal(props) {
  const dispatch = useAppDispatch()
  const { navigateToSettings } = useNavigateWrapper()
  const language = useAppSelector(state => state.present.language.value)
  const changeModal = useAppSelector(state => state.present.settings.changeModal)

  const onModalConfirm = useCallback(() => {
    props.onChangeConfirm()
    dispatch(toggleChangeModal(false))
  }, [dispatch, props])

  const onModalCancel = useCallback(() => {
    dispatch(toggleChangeModal(false))
    props.onChangeCancel()
    navigateToSettings()
  }, [dispatch, navigateToSettings, props])

  return (
    <Modal
      title={renderTranslation(language, TranslationKeys.confirmChangeModalTitle)}
      open={changeModal}
      closable={true}
      onCancel={e => {
        dispatch(toggleChangeModal(false))
      }}
      width={400}
      footer={null}
      className={'confirm-change-modal'}
      getContainer={props.bodyref.current}
    >
      <div className='modal-body-text'>{renderTranslation(language, TranslationKeys.confirmChangeModalBody)}</div>
      <div className='modal-body-btn-box'>
        <Button className='btn confirm-btn' onClick={onModalConfirm}>
          {renderTranslation(language, TranslationKeys.confirmChangeModalConfirm)}
        </Button>
        <Button className='btn decline-btn' onClick={onModalCancel}>
          {renderTranslation(language, TranslationKeys.confirmChangeModalCancel)}
        </Button>
      </div>
    </Modal>
  )
}

export default SettingsChangeModal
